import classNames from 'classnames';
import {Button} from 'components/Button';
import {getGridColumnStyles} from 'components/Grid';
import {INFO_BLOCK_TYPE, InfoBlock} from 'components/InfoBlock';
import {InputCaption} from 'components/InputCaption';
import {SvgIcon} from 'components/SvgIcon';
import {TPropsWithClassName} from 'core/types';
import {DELIVERY_ADDRESS_FIELD_NAME} from 'modules/checkout/constants/fields';
import {useCheckoutFormikContext} from 'modules/checkout/hooks/useCheckoutFormikContext';
import {useIsLoggedIn} from 'modules/user/hooks/useIsLoggedIn';
import plusIcon from 'public/icons/plus.svg';
import React, {ButtonHTMLAttributes, memo, MouseEventHandler} from 'react';

import style from './style.module.scss';
interface IProps extends TPropsWithClassName {
    onClick: MouseEventHandler;
}

const columnStyle = getGridColumnStyles();

interface IButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>, TPropsWithClassName {}

const buttonComponent: FC<IButtonProps> = ({className, onClick}) => (
    <Button className={className} leftIcon={<SvgIcon svg={plusIcon} />} onClick={onClick} size="medium">
        Добавить адрес
    </Button>
);

export const EmptyAddressList = memo<IProps>(function EmptyAddressList({onClick, className}) {
    const isLoggedIn = useIsLoggedIn();
    const contentText = `Добавьте адрес доставки${isLoggedIn ? ', чтобы быстрее оформлять заказы' : ''}`;

    const {getFieldMeta, submitCount} = useCheckoutFormikContext();
    const fieldMeta = getFieldMeta(DELIVERY_ADDRESS_FIELD_NAME);

    const isOnceSubmitted = Boolean(submitCount);

    return (
        <div className={columnStyle}>
            <InfoBlock
                ButtonComponent={buttonComponent}
                className={classNames(className, style.root, columnStyle)}
                contentText={contentText}
                isHideIcon
                onClick={onClick}
                type={INFO_BLOCK_TYPE.warning}
            />
            {(isOnceSubmitted || fieldMeta.touched) && fieldMeta.error && (
                <InputCaption className={columnStyle} errorText={fieldMeta.error} />
            )}
        </div>
    );
});
